module.exports = __webpack_public_path__ + "img/一体化.28356fd3.png";